<template>
    <div>
        <!-- <div>
            <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

        </div> -->

        <v-container fluid>
            <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
                <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
                <v-btn dark text @click="snackbar = false">Close</v-btn>
            </v-snackbar>
            <v-overlay :value="overlay">
                <v-progress-circular indeterminate size="64"></v-progress-circular>
            </v-overlay>

            <v-card class="box">
                <v-toolbar flat dense class="toolbar">
                    <v-toolbar-title>Faculty Canteen Report</v-toolbar-title>
                    <v-divider class="mx-4" inset vertical></v-divider>
                    <v-spacer></v-spacer>
                </v-toolbar>
                <br>
                <v-row justify="center" dense>
                    <v-col cols="12" sm="3" md="3">
                        <v-autocomplete color="#0F2027" dense rounded required v-model="ay" :items="ay_list"
                            item-text="ay" item-value="id" label="Academic Year" outlined persistent-hint
                            hint="Please Select Academic Year" />
                    </v-col>
                    <v-col cols="12" sm="3" md="3">
                        <v-autocomplete color="#0F2027" dense rounded required v-model="month" :items="month_list"
                            item-text="name" item-value="id" label="Month" outlined persistent-hint
                            hint="Please Select Month" />
                    </v-col>
                    <v-col col="12" sm="2" md="2" v-if="this.ay && this.month">
                        <v-btn rounded color="warning" @click="fetchData()">Fetch</v-btn>
                    </v-col>
                </v-row>
            </v-card>

            <v-card class="box" v-if="faculty_canteen_fees_list != ''">
                <v-row>
                    <v-col cols="12" sm="1" md="1">
                        <v-btn v-if="faculty_canteen_fees_list != '' && faculty_canteen_fees_list != null"
                            class="ml-2 mt-5 no-display" rounded color="success" outlined
                            @click="fnExcelReport('my-table-id', 'faculty_canteen_report')" :loading="loader">
                            <v-icon color="success">mdi-export</v-icon>Export
                        </v-btn>
                    </v-col>
                    <v-col cols="12" sm="4" md="4"></v-col>
                    <v-col v-if="faculty_canteen_fees_list != '' && faculty_canteen_fees_list != null"
                        class="mr-2 no-display" cols="12" sm="6" md="6">
                        <v-text-field v-model="search" append-icon="mdi-magnify" label="Search" single-line
                            hide-details></v-text-field>
                    </v-col>

                </v-row>

                <v-data-table :headers="headers" :items="faculty_canteen_fees_list" id="my-table-id" :search="search">
                    <template v-slot:top>
                        <v-toolbar flat class="toolbar">
                            <v-toolbar-title>Faculty Canteen Report List</v-toolbar-title>
                            <v-divider class="mx-4" inset vertical></v-divider>
                            <v-spacer></v-spacer>
                        </v-toolbar>
                    </template>
                </v-data-table>
            </v-card>
        </v-container>
    </div> <!-- /. root div -->
</template>
<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
export default {
    components: {
        Breadcrumbs,
    },
    data: () => ({
        loader: false,
        snackbar_msg: "",
        color: "",
        // extraBreadcrumbItems: [


        // ],
        // breadcrumbClass: "breadcrumb-style1",
        search: "",
        snackbar: false,
        overlay: false,
        headers: [
            { text: "Employee", value: "employee_name" },
            { text: "Month", value: "month" },
            { text: "Amount To Pay", value: "amount_to_pay" },
            { text: "Amount Paid", value: "paid_till_now" },
            { text: "Balance", value: "balance" },
            // { text: "Academicyear", value: "academicyear" },
        ],
        month_list: [], month: "", ay_list: [], ay: "",
        pg_loader: false, faculty_canteen_fees_list: []
    }),
    methods: {
        fnExcelReport(id, name) {
            var tab_text = '<html xmlns:x="urn:schemas-microsoft-com:office:excel">';
            tab_text = tab_text + "<head><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet>";
            tab_text = tab_text + "<x:Name>Test Sheet</x:Name>";
            tab_text = tab_text + "<x:WorksheetOptions><x:Panes></x:Panes></x:WorksheetOptions></x:ExcelWorksheet>";
            tab_text = tab_text + "</x:ExcelWorksheets></x:ExcelWorkbook></xml></head><body>";
            tab_text = tab_text + "<table style='border-collapse:collapse;' border='1'>";
            var exportTable = $("#" + id).clone();
            exportTable.find("input").each(function (index, elem) {
                $(elem).remove();
            });
            exportTable.find("img").remove();
            exportTable.find("th, td").each(function () {
                $(this).css("border", "1px solid black");
            });
            tab_text = tab_text + exportTable.html();
            tab_text = tab_text + "</table></body></html>";
            var fileName = name + "_" + parseInt(Math.random() * 10000000000) + ".xls";

            const blob = new Blob([tab_text], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
            const filename = name + ".xls";

            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                // For IE
                window.navigator.msSaveOrOpenBlob(blob, filename);
            } else {
                // For modern browsers
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement("a");
                a.href = url;
                a.download = filename;
                a.click();
                window.URL.revokeObjectURL(url);
            }
        },
        fetchData() {
            this.faculty_canteen_fees_list = [];
            const data = {
                ay: this.ay,
                month: this.month,
            };
            this.overlay = true;
            axios
                .post("/Canteen/getFacultyCanteenReport", data)
                .then((res) => {
                    if (res.data.flag == "YES") {
                        this.faculty_canteen_fees_list = res.data.faculty_canteen_fees_list
                    } else if (res.data.flag == "No") {

                        this.showSnackbar("red", res.data.snackbar);
                        sessionStorage.setItem("error-trace", res.data.error_trace);
                    }
                    else {
                        this.showSnackbar("red", res.data.snackbar);
                        sessionStorage.setItem("error-trace", res.data.error_trace);
                    }
                    this.overlay = false;
                })
                .catch((error) => {
                    //  this.onerror(error);
                    this.overlay = false;
                })
                .finally(() => {
                    this.overlay = false;
                    // this.selected_date=""
                });
        },
        onLoad() {
            axios
                .post("Canteen/facultyCanteenHome")
                .then((res) => {
                    if (res.data.flag == "YES") {
                        (this.ay_list = res.data.ay_list), (this.ay = res.data.current_ay);
                        this.month_list = res.data.month_list;
                        this.overlay = false;
                    } else {
                        this.showSnackbar("#b71c1c", res.data.status_reason);
                    }
                })
                .catch((error) => {
                    this.showSnackbar("#b71c1c", "Something went wrong!!!");
                    this.overlay = false;
                })
                .finally(() => {
                    this.overlay = false;
                });
        },
        showSnackbar(clr, msg) {
            this.snackbar = true;
            this.color = clr;
            this.snackbar_msg = msg;
        },
    },

    mounted() {
        this.onLoad();
    },
    watch: {},
};
</script>
<style scoped>
.radiospace {
    margin: 1rem !important;
    padding: 0%;
}

sub-row {
    border: 2px solid #424093;
    margin: 1rem;
    border-radius: 5px;
}

i {
    font-size: 20px !important;
}

.v-card__title {
    border: 1px solid #80808040;
    font-weight: bold;
    background-color: #424093;
    color: white;
    text-align: center;
    /* margin-top: 1.5rem; */
}

.card-border {
    border: 2px solid darkblue;
    border-radius: 10px;
    /* padding: 5px; */
    /* margin: 1rem !important; */
    width: auto;
}

.tx-bold {
    font-weight: bold;
    font-size: 14px;
    color: black;
}

i {
    font-size: 26px;
    cursor: pointer;
}

theme--light.v-btn:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined) {
    background-color: #424093 !important;
    color: white !important;
    margin-top: 2.35rem;
    border-radius: 20px;
}

/*.theme--light.v-btn:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined):hover {
    background-color: orange !important;
    color: black !important;
} */

@media only screen and (max-width: 600px) {}

.imgs {
    border: 1px solid #ddd;
    border-radius: 4px;
    padding: 5px;
    width: 150px;
    cursor: zoom-in;
}

.imgs-preview {
    border: 1px solid #ddd;
    border-radius: 4px;
    padding: 5px;
    width: auto;
}

v-simple-table {
    border-collapse: collapse;
    border-spacing: 0;
    width: auto;
    border: 1px solid #ddd;
}

th {
    color: white;
    font-weight: bold;
    text-align: center !important;
}

td,
th {
    padding: 6px;
    border: 1px solid #ccc;
    text-align: center;
}

@media all and (max-width: 900px) {
    .padding-bot {
        padding: 8px;
    }
}

@media all and (min-width: 1000px) {
    .padding-metting {
        padding-right: 22px;
    }
}

@media (min-width: 320px) and (max-width: 350px) {
    .padding-bot {
        font-size: 11.6px;
    }
}

@media (min-width: 1000px) and (max-width: 1050px) {
    .padding-bot {
        font-size: 9.6px;
    }
}

.slide {
    color: red;
    font-weight: bold;
    margin-left: 10px;
}

.note-list {
    background-color: orange;
}
</style>